import React from 'react';

import { ListWithTitle } from '../components/ListWithTitle';
import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const DisclosureOrTransferOfData = () => {
  return (
    <>
      <Subtitle>Disclosure or Transfer of Data</Subtitle>
      <Paragraph>
        Glints agrees to take all practicable steps to keep all personal
        information and data of Users confidential and/or undisclosed, subject
        to the following.
      </Paragraph>
      <ListWithTitle
        title={
          <>
            Generally speaking, Glints will only disclose and/or transfer your
            personal information and/or data to Glints personnel and staff for
            the purpose of providing services to you and corporate clients of
            Glints who have made specific requests for such information and/or
            data with your prior consent. However, Glints may disclose and/or
            transfer such information and/or data to third parties under the
            following circumstances:
          </>
        }
        list={[
          <>
            where the information and/or data is disclosed and/or transferred to
            any third party suppliers or external service providers who have
            been duly authorized by Glints to use such information and/or data
            and who will facilitate the services on the Site, under a duty of
            confidentiality;
          </>,
          <>
            where the information and/or data is disclosed and/or transferred to
            any agents, affiliates or associates of Glints who have been duly
            authorized by Glints to use such information and/or data;
          </>,
          <>
            where permitted under the “Terms and Conditions” including the
            “Talent Search Terms and Conditions” (see the Profiles Section
            below);
          </>,
          <>
            where Glints needs to protect and defend its rights and property;
          </>,
          <>
            where Glints considers necessary to do so in order to comply with
            the applicable laws and regulations, including without limitation
            compliance with a judicial proceeding, court order, or legal process
            served on the Site;
          </>,
          <>
            where Glints deems necessary in order to deliver the products and
            services that we offer and cultivate a positive user experience;
            and/or
          </>,
          <>
            where Glints deems necessary in order to maintain and/or improve the
            services on the Site.
          </>,
        ]}
      />
      <Paragraph>
        Personal data collected via the Site may be transferred, stored and
        processed in any country in which Glints or any member of the Glints
        Group operates. By using the Site, you are deemed to have agreed to,
        consented to and authorized Glints to disclose and/or transfer your
        personal information and data under the circumstances stated above, as
        well as to any transfer of information (including the Information)
        outside of your country.
      </Paragraph>
    </>
  );
};
